export default new class Search {
    constructor() {
        this.sSearchClass = '_search';
        this.sSearchResultClass = '_search-result';

        this.handler();
    }

    handler() {
        $(document).on('keyup', `.${this.sSearchClass}`, (obEvent) => {
            const sSearch = $(obEvent.target).val();

            oc.request(obEvent.target, 'Search::onSearch', {
                data: {
                    query: sSearch
                },
                update: {
                    'search/result': `.${this.sSearchResultClass}`
                }
            });
        });
    }
}();
